/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { AnnotationSettingsModule } from './annotation-settings.module';
export { AnnotationSettingsComponent } from './annotation-settings.component';